import { SPACING_TOKENS } from '../../constants/tokens.mjs';

const MIN_SPACING = SPACING_TOKENS['space-2'];
const MIN_SPACING_NUMBER = parseInt(MIN_SPACING, 10);
const MIN_POPOVER_HEIGHT_PX = 120;
function getPopoverLayout({
  anchorLayout,
  containerSize,
  scrollSize,
  options
}) {
  if (!scrollSize || !(containerSize !== null && containerSize !== void 0 && containerSize.height) || !(containerSize !== null && containerSize !== void 0 && containerSize.width)) {
    return anchorLayout;
  }
  const {
    top,
    bottom
  } = calculatePopoverVerticalPosition({
    anchorLayout,
    containerHeight: containerSize.height,
    popoverScrollHeight: scrollSize.height,
    popoverCustomHeight: options.height
  });
  const x = calculatePopoverLeftPosition({
    anchorLayout,
    containerWidth: containerSize.width,
    popoverCustomWidth: options.width,
    popoverScrollWidth: scrollSize.width,
    alignment: options.alignment
  });
  const maxHeight = bottom ? `calc(100vh - ${MIN_SPACING} - ${bottom}px)` : `calc(100vh - ${MIN_SPACING} - ${top}px)`;
  return {
    top,
    bottom,
    left: x,
    height: options.height,
    width: options.width,
    transition: 'none',
    maxHeight: options.maxHeight ? options.maxHeight : maxHeight,
    ...(options.maxWidth ? {
      maxWidth: options.maxWidth
    } : {})
  };
}
function calculatePopoverVerticalPosition({
  anchorLayout,
  containerHeight,
  popoverScrollHeight,
  popoverCustomHeight
}) {
  // Calculates the top position for the popover to use the maximum allowed space
  // The popover height property is set based on the top, in the DEFAULT_OVERRIDES

  const maxSpaceBelow = containerHeight - anchorLayout.bottom - MIN_SPACING_NUMBER;
  const maxSpaceAbove = anchorLayout.top - MIN_SPACING_NUMBER;

  // Desirable popover height
  const idealPopoverHeight = popoverCustomHeight || popoverScrollHeight;
  const popoverMinHeight = Math.min(MIN_POPOVER_HEIGHT_PX, idealPopoverHeight);

  // Position popover at top of container if anchor is offscreen
  if (anchorLayout.top < MIN_SPACING_NUMBER) {
    return {
      top: MIN_SPACING_NUMBER + anchorLayout.height
    };
  }

  // Flip to the top if there is not enough space below the anchor
  if (maxSpaceBelow < popoverMinHeight && maxSpaceAbove > popoverMinHeight && anchorLayout.distanceBottom) {
    return {
      bottom: anchorLayout.distanceBottom + anchorLayout.height + MIN_SPACING_NUMBER
    };
  }

  // Otherwise show it below the anchor
  return {
    top: anchorLayout.bottom + MIN_SPACING_NUMBER
  };
}
const calculatePopoverLeftPosition = ({
  anchorLayout,
  popoverCustomWidth,
  popoverScrollWidth,
  containerWidth,
  alignment
}) => {
  const anchorCenter = anchorLayout.left + anchorLayout.width / 2;
  const popoverWidth = popoverCustomWidth || popoverScrollWidth;
  const popoverLeft = (() => {
    switch (alignment) {
      case 'center':
        return anchorCenter - popoverWidth / 2;
      case 'left':
        return anchorLayout.left;
      case 'right':
        return anchorLayout.right - popoverWidth;
    }
  })();
  const popoverRight = popoverLeft + popoverWidth;

  // Align to left of container if overflowing on the left
  if (popoverLeft < MIN_SPACING_NUMBER) {
    return Math.max(MIN_SPACING_NUMBER, Math.min(MIN_SPACING_NUMBER, anchorLayout.left));
  }

  // Align to right of container if overflowing on the right
  const rightCutoff = containerWidth - MIN_SPACING_NUMBER;
  if (popoverRight > rightCutoff) {
    return rightCutoff - popoverWidth;
  }
  return popoverLeft;
};

export { MIN_POPOVER_HEIGHT_PX, MIN_SPACING, MIN_SPACING_NUMBER, calculatePopoverLeftPosition, calculatePopoverVerticalPosition, getPopoverLayout };
